import { application } from "./application"

import NavController from "./nav_controller"
import TimeEntryEditController from "./time_entry_edit_controller"
import StartPopupController from "./start_popup_controller"
import TeEditModalController from "./te_edit_modal_controller"
import TeTimelineController from "./te_timeline_controller"
import TabsController from "./tabs_controller"
import QuickCreateController from "./quick_create_controller"
import FilterScopeController from "./filter_scope_controller"
import AutoSubmitController from "./auto_submit_controller"
import IterationToggleController from "./iteration_toggle_controller"
import TaskControlsController from "./task_controls_controller"
import OverlapModalController from "./overlap_modal_controller"
import FlashController from "./flash_controller"
import InlineEditController from "./inline_edit_controller"
import CreateFormController from "./create_form_controller"
import LiveClockController from "./live_clock_controller"
import DayNewEntryController from "./day_new_entry_controller"

application.register("nav", NavController)
application.register("time-entry-edit", TimeEntryEditController)
application.register("start-popup", StartPopupController)
application.register("te-edit-modal", TeEditModalController)
application.register("te-timeline", TeTimelineController)
application.register("tabs", TabsController)
application.register("quick-create", QuickCreateController)
application.register("filter-scope", FilterScopeController)
application.register("auto-submit", AutoSubmitController)
application.register("iteration-toggle", IterationToggleController)
application.register("task-controls", TaskControlsController)
application.register("overlap-modal", OverlapModalController)
application.register("flash", FlashController)
application.register("inline-edit", InlineEditController)
application.register("create-form", CreateFormController)
application.register("live-clock", LiveClockController)
application.register("day-new-entry", DayNewEntryController)
